var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModuleContainer",
    _vm._b(
      {
        attrs: { btnWidth: 70 },
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _vm.current_baseMaps
                  ? _c("MapControlButton", {
                      attrs: { tooltip: _vm.title },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c(
                                  "map-card",
                                  {
                                    staticClass:
                                      "clickable base-map-button__container",
                                    attrs: { height: "70px", width: "70px" },
                                    on: { click: _vm.onToggleList },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "base-map-button__content",
                                      },
                                      [
                                        _c(
                                          "map-image",
                                          {
                                            attrs: {
                                              src: _vm.current_baseMaps
                                                .thumbnail,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "base-map-button__title",
                                              },
                                              [
                                                _vm.controlIcon
                                                  ? _c(
                                                      "map-icon",
                                                      {
                                                        attrs: {
                                                          dark: "",
                                                          small: "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.controlIcon
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("SvgIcon", {
                                                      attrs: {
                                                        type: "mdi",
                                                        path: _vm.path.layer,
                                                      },
                                                    }),
                                                _c("div", {}, [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.title ||
                                                          _vm.$map.trans(
                                                            "map.basemap.title"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        583161492
                      ),
                    })
                  : _c("div"),
              ]
            },
            proxy: true,
          },
          {
            key: "draggable",
            fn: function (props) {
              return [
                _vm.show
                  ? _c(
                      "DraggablePopup",
                      _vm._b(
                        {
                          attrs: {
                            height:
                              _vm.sizeBaseMap *
                                (Math.floor(_vm.c_baseMaps.length / 3) + 1) +
                              48 +
                              10,
                            show: _vm.show,
                            "is-resizable": false,
                            title: _vm.$map.trans("map.basemap.setting"),
                            width: _vm.sizeBaseMap * 3 + 24,
                          },
                          on: {
                            "update:show": function ($event) {
                              _vm.show = $event
                            },
                          },
                        },
                        "DraggablePopup",
                        props,
                        false
                      ),
                      [
                        _c(
                          "div",
                          { staticClass: "base-map-control-setting" },
                          _vm._l(_vm.c_baseMaps, function (baseMap) {
                            return _c(
                              "div",
                              {
                                key: baseMap.id,
                                staticClass:
                                  "clickable base-map-control-setting-item",
                                style: { width: _vm.sizeBaseMap + "px" },
                                attrs: { title: baseMap.title },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClick(baseMap)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      width: _vm.sizeBaseMap - 34 + "px",
                                      height: _vm.sizeBaseMap - 34 + "px",
                                    },
                                  },
                                  [
                                    _c("map-image", {
                                      attrs: { src: baseMap.thumbnail },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "base-map-control-setting-item__title",
                                    class: {
                                      "base-map-control-setting-item__active":
                                        _vm.current_baseMaps &&
                                        baseMap.id == _vm.current_baseMaps.id,
                                    },
                                    staticStyle: { "font-size": "14px" },
                                  },
                                  [_vm._v(" " + _vm._s(baseMap.title) + " ")]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }